import React, { useEffect, useRef } from "react";
import Header5 from "../PageLayout/header5";
import Footer from "../PageLayout/Footer";
import LandingPage from "./LandingPage";

const MaintenanceBanner = React.forwardRef((_, ref) => (
  <div ref={ref} className="maintenance-banner">
    <span className="maintenance-title">Scheduled Maintenance</span>
    <span>
      Some functionality may be unavailable while we refresh the experience. Thank you for your patience while our
      team completes the upgrade.
    </span>
  </div>
));
MaintenanceBanner.displayName = "MaintenanceBanner";

export default function LandingHome() {
    const bannerRef = useRef(null);

    useEffect(() => {
        const bannerEl = bannerRef.current;
        const updateOffsets = () => {
            const headerHeight = document.querySelector('.custom-navbar')?.offsetHeight || 64;
            const bannerHeight = bannerEl?.offsetHeight || 52;
            document.documentElement.style.setProperty('--nav-height', `${headerHeight}px`);
            document.documentElement.style.setProperty('--banner-height', `${bannerHeight}px`);
        };

        document.body.classList.add('has-maintenance-banner');
        updateOffsets();

        const resizeObserver = bannerEl && 'ResizeObserver' in window ? new ResizeObserver(updateOffsets) : null;
        if (resizeObserver && bannerEl) resizeObserver.observe(bannerEl);
        window.addEventListener('resize', updateOffsets);

        return () => {
            window.removeEventListener('resize', updateOffsets);
            if (resizeObserver && bannerEl) resizeObserver.disconnect();
            document.body.classList.remove('has-maintenance-banner');
            document.documentElement.style.removeProperty('--nav-height');
            document.documentElement.style.removeProperty('--banner-height');
        };
    }, []);

    return <>
        <Header5 />
        <MaintenanceBanner ref={bannerRef} />
        <LandingPage />
        <Footer />
    </>;
}
